import React, { createContext, useContext, useState } from 'react';

const WorkspaceContext = createContext();

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};

export const WorkspaceProvider = ({ children }) => {
  const [workspaceData, setWorkspaceData] = useState({
    userType: '',
    selectedExpertise: [],
    recommendedTools: [],
    platforms: [],
    currentTask: ''
  });

  const updateWorkspaceData = (data) => {
    setWorkspaceData(prev => {
      // Prevent unnecessary updates if data hasn't changed
      const newData = { ...prev, ...data };
      if (JSON.stringify(prev) === JSON.stringify(newData)) {
        return prev;
      }
      return newData;
    });
  };

  return (
    <WorkspaceContext.Provider value={{ workspaceData, updateWorkspaceData }}>
      {children}
    </WorkspaceContext.Provider>
  );
};
